"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizationAuthSuiteService = exports.authorizationAuthSuiteService = void 0;
var tslib_1 = require("tslib");
var auth_suite_fetch_1 = require("../../auth-suite-fetch");
var models_1 = require("../../models");
var parse_url_service_1 = require("../parse-url-service");
var storage_service_1 = require("../storage-service");
var requestRoute = "mvpd/";
var accessRequestRoute = "access";
var loginRequestRoute = "login";
var getAuthenticationUrl = function (request) {
    var path = "".concat(requestRoute).concat(request.mvpdCode, "/").concat(loginRequestRoute);
    var requestParams = [models_1.AuthSuiteRequestParams.ActivationCode, models_1.AuthSuiteRequestParams.CallbackUrl];
    var authSuiteRequestData = storage_service_1.authSuiteDataLocalStorageService.getAuthSuiteRequestData();
    var requestData = tslib_1.__assign(tslib_1.__assign({}, request), { callbackUrl: (0, parse_url_service_1.parseUrl)(tslib_1.__assign(tslib_1.__assign({}, request), authSuiteRequestData)) });
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization
        .get({
        path: path,
        request: requestData,
        requestParams: requestParams,
    })
        .then(function (response) {
        return tslib_1.__assign(tslib_1.__assign({}, response), { authenticationUrl: (0, parse_url_service_1.getUrlWithRegCodeParamMovedToStartOfQueryString)(response.authenticationUrl) });
    });
};
var linkDeviceWithProvider = function (request) {
    var path = "".concat(accessRequestRoute, "/").concat(requestRoute).concat(request.mvpdCode);
    var requestParams = [models_1.AuthSuiteRequestParams.ActivationCode, models_1.AuthSuiteRequestParams.AuthorizationCode];
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
        path: path,
        request: request,
        requestParams: requestParams,
    });
};
var disconnectDevice = function (removeAccessTokens) {
    if (removeAccessTokens === void 0) { removeAccessTokens = false; }
    var path = "".concat(accessRequestRoute);
    return new Promise(function (resolve, reject) {
        auth_suite_fetch_1.authSuiteFetchWithAuthorization
            .delete({
            path: path,
        })
            .then(function (result) {
            if (removeAccessTokens) {
                storage_service_1.authSuiteDataLocalStorageService.removeAccessTokens();
            }
            resolve(result);
        })
            .catch(function (error) {
            reject(error);
        });
    });
};
exports.authorizationAuthSuiteService = {
    disconnectDevice: disconnectDevice,
    getAuthenticationUrl: getAuthenticationUrl,
    linkDeviceWithProvider: linkDeviceWithProvider,
};
var AuthorizationAuthSuiteService = /** @class */ (function () {
    function AuthorizationAuthSuiteService() {
        return exports.authorizationAuthSuiteService;
    }
    return AuthorizationAuthSuiteService;
}());
exports.AuthorizationAuthSuiteService = AuthorizationAuthSuiteService;
